module.exports = __webpack_public_path__ + "static/media/sloth.a0a5536d.png";